export default function SavedColors({
  savedColors,
  deleteFromSaved,
  copyColor,
  copiedColor,
}) {
  return (
    <div className="saved-section">
      <h2>Saved Colors ({savedColors.length})</h2>
      <div className="saved-colors-grid">
        {savedColors.map((color) => (
          <div key={color} className="mini-color-wrapper">
            <div
              className="mini-color-card"
              style={{ backgroundColor: color }}
              data-tooltip={copiedColor ? "Copied!" : color}
              onClick={() => copyColor(color)}
            />
            <button
              className="delete-btn"
              onClick={() => deleteFromSaved(color)}
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
